import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import { Grid } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles((theme: Theme) => ({
    error: {
        color: "#FFF",
        backgroundColor: "rgb(220, 0, 78)",
        "&:hover": {
            backgroundColor: "rgb(154, 0, 54)"
        }
    },
    deleteLabel: {
        textTransform: "uppercase",
        color: "black",
        fontSize: "13px"
    },
    deleteOptionLabel: {
        margin: 0
    },
    deleteOption: {
        textTransform: "uppercase",
    }
}));

const IEDistributionDelete = (props) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                        <FormControl component="fieldset">
                            <label className={classes.deleteLabel}>Delete</label>
                            <RadioGroup
                                value={props.ieDistributionDeletePopupData.isDeleteAll.value ? "ALL" : "SINGLE"}
                                onChange={props.onDeletePopupChange}
                            >
                                <FormControlLabel
                                    value="SINGLE"
                                    control={<Radio />}
                                    label={<p className={classes.deleteOptionLabel}>THIS RECORD ONLY.</p>} />
                                <FormControlLabel
                                    value="ALL"
                                    control={<Radio />}
                                    label={<p className={classes.deleteOptionLabel}>ALL THE RECORDS RELATED TO <b>{props.ieDistributionDeletePopupData.ieName.value.toUpperCase()}.</b></p>} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" className={classes.error} onClick={props.onDeleteIEDistribution}>
                    Delete
                </Button>
            </DialogActions>
        </React.Fragment>
    )

}

IEDistributionDelete.propTypes = {
    ieDistributionDeletePopupData: PropTypes.object,
    onDeleteIEDistribution: PropTypes.func,
    onDeletePopupChange: PropTypes.func,
}

export default IEDistributionDelete;
